export enum EComponentName {
    NotMentioned,
    onboarding
}